var _g, _path, _path2, _ellipse, _ellipse2, _path3, _path4, _ellipse3, _ellipse4, _path5, _path6, _ellipse5, _ellipse6, _g2, _mask, _g3, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTstormN(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 424,
    height: 529,
    fill: "none",
    viewBox: "0 0 424 529",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_30_694)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_30_694)",
    fillRule: "evenodd",
    d: "M208.467 307H143.677L114.037 405.638H146.929L119.547 507L210.367 383.565L162.01 383.565L208.467 307Z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    filter: "url(#filter1_f_30_694)",
    opacity: 0.5
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_radial_30_694)",
    fillOpacity: 0.3,
    fillRule: "evenodd",
    d: "M249.55 420.548C246.512 426.652 240.354 430.828 233.252 430.828C223.137 430.828 214.938 422.359 214.938 411.911C214.938 410.414 215.1 408.9 215.408 407.363C213.934 410.999 213.107 414.468 213.107 417.855C213.107 428.302 221.306 436.772 231.42 436.772C240.65 436.772 248.285 429.72 249.55 420.548Z",
    clipRule: "evenodd"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint2_radial_30_694)",
    d: "M249.551 417.761C249.551 428.209 241.352 436.678 231.237 436.678C221.123 436.678 212.923 428.209 212.923 417.761C212.923 407.313 220.798 396.071 231.237 381.611C240.028 395.675 249.551 407.313 249.551 417.761Z",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 235.907,
    cy: 402.212,
    fill: "url(#paint3_radial_30_694)",
    rx: 18.772,
    ry: 19.808
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 225.285,
    cy: 423.802,
    fill: "url(#paint4_radial_30_694)",
    rx: 18.772,
    ry: 19.808
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    filter: "url(#filter2_f_30_694)",
    opacity: 0.5
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint5_radial_30_694)",
    fillOpacity: 0.3,
    fillRule: "evenodd",
    d: "M338.174 432.432C335.136 438.832 328.978 443.21 321.876 443.21C311.761 443.21 303.562 434.331 303.562 423.378C303.562 421.808 303.724 420.22 304.032 418.608C302.558 422.42 301.731 426.058 301.731 429.608C301.731 440.561 309.93 449.44 320.044 449.44C329.273 449.44 336.908 442.048 338.174 432.432Z",
    clipRule: "evenodd"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint6_radial_30_694)",
    d: "M338.175 429.51C338.175 440.463 329.975 449.342 319.861 449.342C309.747 449.342 301.547 440.463 301.547 429.51C301.547 418.557 309.422 406.771 319.861 391.611C328.652 406.355 338.175 418.557 338.175 429.51Z",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 324.531,
    cy: 413.208,
    fill: "url(#paint7_radial_30_694)",
    rx: 18.772,
    ry: 20.767
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 313.909,
    cy: 435.844,
    fill: "url(#paint8_radial_30_694)",
    rx: 18.772,
    ry: 20.767
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    filter: "url(#filter3_f_30_694)",
    opacity: 0.5
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint9_radial_30_694)",
    fillOpacity: 0.3,
    fillRule: "evenodd",
    d: "M298.103 498.853C294.154 506.729 286.148 512.118 276.915 512.118C263.767 512.118 253.108 501.19 253.108 487.709C253.108 485.776 253.318 483.822 253.719 481.837C251.802 486.529 250.727 491.007 250.727 495.377C250.727 508.857 261.386 519.786 274.535 519.786C286.532 519.786 296.457 510.687 298.103 498.853Z",
    clipRule: "evenodd"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint10_radial_30_694)",
    d: "M298.104 495.256C298.104 508.737 287.445 519.665 274.296 519.665C261.148 519.665 250.489 508.737 250.489 495.256C250.489 481.776 260.726 467.269 274.296 448.611C285.724 466.758 298.104 481.776 298.104 495.256Z",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 280.367,
    cy: 475.192,
    fill: "url(#paint11_radial_30_694)",
    rx: 24.403,
    ry: 25.559
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 266.559,
    cy: 503.052,
    fill: "url(#paint12_radial_30_694)",
    rx: 24.403,
    ry: 25.559
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_di_30_694)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint13_linear_30_694)",
    fillRule: "evenodd",
    d: "M331.51 1.08608C326.359 0.370135 321.096 0 315.747 0C253.345 0 202.759 50.368 202.759 112.5C202.759 174.632 253.345 225 315.747 225C362.68 225 402.929 196.509 420 155.95C418.899 155.983 417.793 156 416.683 156C359.689 156 313.487 111.676 313.487 57C313.487 36.2527 320.14 16.996 331.51 1.08608Z",
    clipRule: "evenodd"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-15-inside-1_30_694",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M319.761 367L150.358 367C67.3176 367 0 299.843 0 217C0 134.157 67.3176 67 150.358 67C217.131 67 273.738 110.423 293.354 170.507C301.767 168.22 310.622 167 319.761 167C375.122 167 420 211.772 420 267C420 322.228 375.122 367 319.761 367Z",
    clipRule: "evenodd"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_30_694)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint14_linear_30_694)",
    fillRule: "evenodd",
    d: "M319.761 367L150.358 367C67.3176 367 0 299.843 0 217C0 134.157 67.3176 67 150.358 67C217.131 67 273.738 110.423 293.354 170.507C301.767 168.22 310.622 167 319.761 167C375.122 167 420 211.772 420 267C420 322.228 375.122 367 319.761 367Z",
    clipRule: "evenodd"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.05,
    d: "M150.358 367V366V367ZM319.761 367V368V367ZM293.354 170.507L292.403 170.817L292.698 171.721L293.616 171.472L293.354 170.507ZM150.358 368L319.761 368V366L150.358 366V368ZM-1 217C-1 300.397 66.7675 368 150.358 368V366C67.8676 366 1 299.288 1 217H-1ZM150.358 66C66.7675 66 -1 133.603 -1 217H1C1 134.712 67.8676 68 150.358 68V66ZM294.304 170.196C274.558 109.712 217.575 66 150.358 66V68C216.687 68 272.918 111.133 292.403 170.817L294.304 170.196ZM293.616 171.472C301.945 169.208 310.711 168 319.761 168V166C310.532 166 301.59 167.232 293.091 169.542L293.616 171.472ZM319.761 168C374.572 168 419 212.326 419 267H421C421 211.217 375.672 166 319.761 166V168ZM419 267C419 321.674 374.572 366 319.761 366V368C375.672 368 421 322.783 421 267H419Z",
    mask: "url(#path-15-inside-1_30_694)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_30_694",
    width: 106.33,
    height: 210,
    x: 109.037,
    y: 302,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_30_694",
    stdDeviation: 2.5
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_30_694",
    width: 52.443,
    height: 45.409,
    x: 205.107,
    y: 399.363,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_30_694",
    stdDeviation: 4
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_30_694",
    width: 52.443,
    height: 46.832,
    x: 293.731,
    y: 410.608,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_30_694",
    stdDeviation: 4
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_30_694",
    width: 63.376,
    height: 53.948,
    x: 242.727,
    y: 473.837,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_30_694",
    stdDeviation: 4
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_di_30_694",
    width: 246.241,
    height: 240,
    x: 177.759,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow_30_694"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_30_694",
    mode: "normal",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -25,
    dy: 15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.607843 0 0 0 0 0.529412 0 0 0 0 0.921569 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    mode: "normal",
    result: "effect2_innerShadow_30_694"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_30_694",
    width: 420,
    height: 348.647,
    x: 0,
    y: 67,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 48.647
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    mode: "normal",
    result: "effect1_innerShadow_30_694"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_30_694",
    x1: 162.202,
    x2: 162.202,
    y1: 307,
    y2: 507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    stopColor: "#FEC255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA031"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_30_694",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(231.42 419.143) rotate(-39.8876) scale(31.5054 23.0513)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CC7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3CC7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004DFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_30_694",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(231.237 419.049) rotate(-39.8885) scale(31.5057 23.0517)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CC7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3CC7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004DFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_30_694",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(235.907 402.212) rotate(58.0492) scale(27.3136 7.73083)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#BDDBF1",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5686F5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_30_694",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(224.278 423.802) rotate(51.9207) scale(14.8469 7.10405)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.674,
    stopColor: "#BDDBF1",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5686F5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_30_694",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(320.044 430.958) rotate(-41.2253) scale(32.1412 23.6889)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CC7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3CC7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004DFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_30_694",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(319.861 430.86) rotate(-41.2258) scale(32.1414 23.6891)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CC7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3CC7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004DFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_30_694",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(324.531 413.208) rotate(59.252) scale(28.2714 7.83033)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#BDDBF1",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5686F5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_30_694",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(312.902 435.844) rotate(53.2273) scale(15.2961 7.22912)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.674,
    stopColor: "#BDDBF1",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5686F5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_30_694",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(274.535 497.038) rotate(-39.6781) scale(40.8324 29.8353)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CC7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3CC7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004DFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_30_694",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(274.296 496.918) rotate(-39.678) scale(40.8323 29.8352)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CC7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3CC7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004DFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_30_694",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(280.367 475.192) rotate(57.8567) scale(35.3176 10.029)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#BDDBF1",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5686F5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_30_694",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(265.249 503.052) rotate(51.7127) scale(19.2121 9.20894)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.674,
    stopColor: "#BDDBF1",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5686F5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_30_694",
    x1: 215.564,
    x2: 378.013,
    y1: 0,
    y2: 257.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B87EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.659,
    stopColor: "#3010AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_30_694",
    x1: 29.423,
    x2: 419.459,
    y1: 67,
    y2: 367.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C1C1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTstormN);
export default __webpack_public_path__ + "static/media/TstormN.9ce6302f5f375f73ce564a5fbd58d3d5.svg";
export { ForwardRef as ReactComponent };